import { StyleSheet } from 'aphrodite';
import { bodyPadding } from '../../../styles/mixins';

export const styles = StyleSheet.create({
  body: {
    ...bodyPadding,
  },
});
